var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"sc-tabs me-auto"},_vm._l((_vm.visibleTabs),function(tab,index){return _c('li',{key:index,staticClass:"sc-tab",class:{ active: _vm.currentTab.name === tab.name },on:{"click":function($event){return _vm.changeTab(tab)}}},[_vm._v("\n    "+_vm._s(tab.name)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }